// extracted by mini-css-extract-plugin
export default {"subtitle_b":"auth_subtitle_b__LFlmh","form_button":"auth_form_button__4lmgo","logo":"auth_logo__57Stq"};